import { z } from 'zod';

const optionalUrl = z.union([z.literal(''), z.url()]).default('');

const EnvSchema = z.object({
  VITE_SUPABASE_URL: z.url({ error: 'VITE_SUPABASE_URL must be the Supabase project URL' }),
  VITE_SUPABASE_PUBLISHABLE_KEY: z
    .string({ error: 'VITE_SUPABASE_PUBLISHABLE_KEY is missing' })
    .min(1, 'VITE_SUPABASE_PUBLISHABLE_KEY is empty'),
  // Empty in development: /api is proxied to the worker by Vite (works from a phone on the same Wi-Fi).
  VITE_WORKER_URL: optionalUrl,
  // Sentry is off until a DSN is set.
  VITE_SENTRY_DSN: optionalUrl,
  VITE_APP_ENV: z.enum(['local', 'prod']).default('local'),
});

export type WebEnv = z.infer<typeof EnvSchema>;

const parsed = EnvSchema.safeParse(import.meta.env);

/** Validated build-time configuration, or the list of problems when it is incomplete. */
export const envResult: { ok: true; env: WebEnv } | { ok: false; problems: string[] } =
  parsed.success
    ? { ok: true, env: parsed.data }
    : { ok: false, problems: parsed.error.issues.map((i) => i.message) };

/** The validated env. Only call after checking `envResult.ok` (the app shell does). */
export function env(): WebEnv {
  if (!envResult.ok) throw new Error(`Web app is not configured: ${envResult.problems.join('; ')}`);
  return envResult.env;
}
